var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActionableInsights(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 37.027 44.132",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43",
    transform: "translate(-0.499 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M25.533,10.97a2.128,2.128,0,1,0-3.009,3.009L26.149,17.6a2.128,2.128,0,0,0,3.009,0L36.9,9.86a2.128,2.128,0,1,0-3.009-3.009L33.04,7.7a8.225,8.225,0,0,0-2.063-1.15V5.586A2.13,2.13,0,0,0,28.85,3.458H22.178V2.72A2.722,2.722,0,0,0,19.458,0H12.018A2.722,2.722,0,0,0,9.3,2.72V5.792A1.513,1.513,0,0,0,10.809,7.3h9.858a1.513,1.513,0,0,0,1.511-1.511V4.753h6.672a.834.834,0,0,1,.833.833v.6a8.223,8.223,0,1,0,0,16.122V42a.834.834,0,0,1-.833.833H2.626A.833.833,0,0,1,1.794,42V5.586a.834.834,0,0,1,.833-.833h4.3a.647.647,0,0,0,0-1.295h-4.3A2.13,2.13,0,0,0,.5,5.586V42a2.13,2.13,0,0,0,2.128,2.128H28.85A2.13,2.13,0,0,0,30.977,42V21.93a8.229,8.229,0,0,0,5.295-7.4.648.648,0,0,0-1.294-.044,6.9,6.9,0,0,1-4.8,6.356.615.615,0,0,0-.108.035A6.932,6.932,0,1,1,28.052,7.313a6.918,6.918,0,0,1,4.063,1.317l-4.461,4.462ZM20.883,5.792a.216.216,0,0,1-.216.216H10.809a.216.216,0,0,1-.216-.216V2.72A1.426,1.426,0,0,1,12.018,1.3h7.441A1.426,1.426,0,0,1,20.883,2.72ZM34.81,7.766a.833.833,0,1,1,1.178,1.178l-7.745,7.745a.832.832,0,0,1-1.178,0L23.44,13.064a.833.833,0,1,1,1.178-1.178L27.2,14.464a.647.647,0,0,0,.915,0Zm0,0",
    transform: "translate(0)",
    fill: "#96006b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_44",
    "data-name": "Group 44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M114.439,188.547H106.55a.647.647,0,0,0,0,1.295h7.889a.647.647,0,1,0,0-1.295Zm0,0",
    transform: "translate(-96.319 -172.295)",
    fill: "#ff0086"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M46.024,111.012H41.667a.647.647,0,1,0,0,1.295h4.357a.647.647,0,1,0,0-1.295Zm0,0",
    transform: "translate(-37.028 -101.443)",
    fill: "#ff0086"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M106.549,224.689h7.889a.647.647,0,1,0,0-1.295h-7.889a.647.647,0,0,0,0,1.295Zm0,0",
    transform: "translate(-96.318 -204.139)",
    fill: "#ff0086"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M117.164,279.648H106.549a.647.647,0,0,0,0,1.295h10.615a.647.647,0,1,0,0-1.295Zm0,0",
    transform: "translate(-96.318 -255.543)",
    fill: "#ff0086"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M106.549,315.792h5.307a.647.647,0,0,0,0-1.295h-5.307a.647.647,0,0,0,0,1.295Zm0,0",
    transform: "translate(-96.318 -287.388)",
    fill: "#ff0086"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M106.549,372.143h7.889a.647.647,0,0,0,0-1.295h-7.889a.647.647,0,0,0,0,1.295Zm0,0",
    transform: "translate(-96.318 -338.882)",
    fill: "#ff0086"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M106.549,406.99h10.615a.647.647,0,1,0,0-1.295H106.549a.647.647,0,0,0,0,1.295Zm0,0",
    transform: "translate(-96.318 -370.726)",
    fill: "#ff0086"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M36.748,182.035a2.615,2.615,0,1,0,2.615,2.615A2.618,2.618,0,0,0,36.748,182.035Zm0,3.935a1.32,1.32,0,1,1,1.32-1.32A1.322,1.322,0,0,1,36.748,185.97Zm0,0",
    transform: "translate(-30.735 -166.344)",
    fill: "#ff0086"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M36.748,274.242a2.615,2.615,0,1,0,2.615,2.615A2.618,2.618,0,0,0,36.748,274.242Zm0,3.936a1.32,1.32,0,1,1,1.32-1.32A1.322,1.322,0,0,1,36.748,278.178Zm0,0",
    transform: "translate(-30.735 -250.603)",
    fill: "#ff0086"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M36.748,365.441a2.615,2.615,0,1,0,2.615,2.615A2.618,2.618,0,0,0,36.748,365.441Zm0,3.935a1.32,1.32,0,1,1,1.32-1.32A1.322,1.322,0,0,1,36.748,369.376Zm0,0",
    transform: "translate(-30.735 -333.941)",
    fill: "#ff0086"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionableInsights);
export default __webpack_public_path__ + "static/media/ActionableInsights.e6b488e7f8057445fa5f5bd6897e9701.svg";
export { ForwardRef as ReactComponent };